import React, {Component} from 'react';
import {BrowserRouter as Router, NavLink as RouterNavLink, Route, Switch} from "react-router-dom";
import {Link} from "react-scroll";
import HomePage from '../HomePage';
import Login from '../user/Login';
import OAuth2RedirectHandler from "../user/OAuth2RedirectHandler";
import {Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink} from 'reactstrap';
import Profile from "../user/Profile";
import TournamentPage from "../tournament/TournamentPage";
import TournamentDetail from "../tournament/TournamentDetail";
import {withTranslation} from "react-i18next";
import BlogPage from "../blog/BlogPage";
import NoticePage from "../notice/NoticePage";
import GripPage from "../grip/GripPage";
import FaqPage from "../faq/FaqPage";
import TournamentLeaderboard2 from "../tournament/TournamentLeaderboard2";
import CatchDetail from "../catch/CatchDetail";
import {isMobile} from 'react-device-detect';
import ResetPasswordPage from "../../page/ResetPassword";
import IcastPage from "../grip/IcastPage";
import Kickstarter from "../grip/Kickstarter";
import ReactGA from "react-ga";


class Header extends Component {
	constructor(props) {
		super(props);
		this.toggle = this.toggle.bind(this);
		this.state = {
			isOpen: false,
			scrolled: false,
		};


	}

	componentDidMount() {

		window.addEventListener('scroll', () => {
			const isTop = window.scrollY < 100;
			if (isTop !== true) {
				this.setState({
					scrolled: true
				});
			} else {
				this.setState({
					scrolled: false
				})
			}
		});
	}


	toggle() {
		if(isMobile) {
			this.setState({
				isOpen: !this.state.isOpen
			});
		}
	}
	render() {

		const { t } = this.props;

		return (
			<Router >
				<div>
					{/*<h1>{t('newsTitle')}</h1>*/}
					<header id="header" className={this.state.scrolled ? 'header-scrolled' : ''}>
						<div className="container">
							<Navbar color="" expand="lg">
								<NavbarBrand tag={RouterNavLink} to={`${process.env.PUBLIC_URL}/`}>
									<img className="logo1" src={require('../../assets/img/logo_2.png')} alt="" />
									<img className="logo2" src={require('../../assets/img/logo_1.png')} alt="" />
								</NavbarBrand>
								<NavbarToggler onClick={this.toggle} />
								<Collapse isOpen={this.state.isOpen} navbar>
									<Nav className="ml-auto" navbar>
										<NavItem>
											<NavLink tag={RouterNavLink} to={`${process.env.PUBLIC_URL}/`} onClick={this.toggle}>Home</NavLink>
										</NavItem>
										<NavItem>
											<NavLink tag={RouterNavLink} to={`${process.env.PUBLIC_URL}/grip`} onClick={this.toggle}>Fishing Grip</NavLink>
										</NavItem>
										<NavItem>
											<NavLink
												className="nav-link"
												to={`${process.env.PUBLIC_URL}/tournament`}
												tag={RouterNavLink}
												onClick={this.toggle}
											>
												Tournament
											</NavLink>
										</NavItem>
										<NavItem>
											<Link className="nav-link" to="route" target="_blank"
														onClick={(event) => {this.toggle(event); event.preventDefault(); ReactGA.event({
															category: 'SHOP',
															action: 'VistShop'
														}); window.open("https://smartstore.naver.com/halasz");}}>
												Shop
											</Link>
										</NavItem>

										{/*<UncontrolledDropdown nav inNavbar>*/}
										{/*	<DropdownToggle nav caret>*/}
										{/*		News*/}
										{/*</DropdownToggle>*/}
										{/*	<DropdownMenu left="true">*/}
										{/*		<DropdownItem tag={RouterNavLink} to={`${process.env.PUBLIC_URL}/blog`} onClick={this.toggle}>News</DropdownItem>*/}
										{/*		<DropdownItem tag={RouterNavLink} to={`${process.env.PUBLIC_URL}/notice`} onClick={this.toggle}>Notice</DropdownItem>*/}
										{/*		<DropdownItem tag={RouterNavLink} to={`${process.env.PUBLIC_URL}/faq`} onClick={this.toggle}>FAQ</DropdownItem>*/}
										{/*	</DropdownMenu>*/}
										{/*</UncontrolledDropdown>*/}
									</Nav>
									{/*<Nav className="ml-auto" navbar>*/}
									{/*	<NavItem>*/}
									{/*		{localStorage.getItem(ACCESS_TOKEN) ?*/}
									{/*			<NavLink className="primary-btn" tag={RouterNavLink} to={`${process.env.PUBLIC_URL}/profile`}>*/}
									{/*				MyPage*/}
									{/*			</NavLink>*/}
									{/*			:*/}
									{/*			<NavLink className="primary-btn" tag={RouterNavLink} to={`${process.env.PUBLIC_URL}/login`}>*/}
									{/*				Log In / Signup*/}
									{/*			</NavLink>*/}
									{/*		}*/}

									{/*	</NavItem>*/}
									{/*</Nav>*/}
								</Collapse>
							</Navbar>
						</div>
					</header>

					<Switch>
						<Route exact strict path={`${process.env.PUBLIC_URL}/`} component={HomePage} />
						<Route path={`${process.env.PUBLIC_URL}/login`} component={Login} />
						<Route path={`${process.env.PUBLIC_URL}/redirect`} component={OAuth2RedirectHandler}></Route>
						<Route path={`${process.env.PUBLIC_URL}/profile`} component={Profile}></Route>
						<Route path={`${process.env.PUBLIC_URL}/tournament/:id`} component={TournamentDetail} />
						<Route path={`${process.env.PUBLIC_URL}/tournament`} component={TournamentPage} />
						<Route path={`${process.env.PUBLIC_URL}/catches/:id`} component={CatchDetail} />
						<Route path={`${process.env.PUBLIC_URL}/blog`} component={BlogPage} />
						<Route path={`${process.env.PUBLIC_URL}/notice`} component={NoticePage} />
						<Route path={`${process.env.PUBLIC_URL}/grip`} component={GripPage} />
						<Route path={`${process.env.PUBLIC_URL}/faq`} component={FaqPage} />
						<Route path={`${process.env.PUBLIC_URL}/icast2020`} component={IcastPage} />
						<Route path={`${process.env.PUBLIC_URL}/kickstarter`} component={Kickstarter} />

						<Route path={`${process.env.PUBLIC_URL}/resetPassword/:id`} component={ResetPasswordPage} />

						<Route path={`${process.env.PUBLIC_URL}/jeju`} component={TournamentLeaderboard2} />
						<Route path={`${process.env.PUBLIC_URL}/blueb`} component={TournamentLeaderboard2} />
						<Route path={`${process.env.PUBLIC_URL}/test`} component={TournamentLeaderboard2} />
					</Switch>

				</div>
			</Router>
		);
	}
}

// export default Header;
export default withTranslation()(Header);
